console.signalR = function () {
  const args = Array.from(arguments)
  const prefixArgs = ['%cSignalR%c:', 'color: #cc54ce; font-weight: bold;']
  const payload = args.length ? ['', ...args] : []

  console.log.apply(console, [...prefixArgs, ...payload])
}
